import React from 'react';
import { Icon } from '~/components';
import { colors } from '~/styles';

export default function Loader() {
  return <Icon icon="spinner" spin color={colors.grey75} />;
}
